import React from "react";
import "./index.scss";
import CustomModal from "../../core/modal";
import { Box, Typography } from "@mui/material";
import {
  getFileExtensionFromUrl,
  getFileNameFromUrl,
  splitFileName,
} from "../../utils";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import ArticleIcon from "@mui/icons-material/Article";
import DescriptionIcon from "@mui/icons-material/Description";
import { Icon } from "@iconify/react";

const AttachmentModal = ({ attachments, onClose, isOemDownload = false }) => {
  const getIconByFileType = (url) => {
    const extension = getFileExtensionFromUrl(url);
    switch (extension) {
      case "pdf":
        return <PictureAsPdfIcon color="error" />;
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return <ImageIcon color="info" />;
      case "doc":
      case "docx":
      case "txt":
        return <ArticleIcon color="primary" />;
      case "xlsx":
        return (
          <Icon
            icon="vscode-icons:file-type-excel"
            width="1.5rem"
            height="1.5rem"
          />
        );
      default:
        return <DescriptionIcon color="primary" />;
    }
  };
  return (
    <div>
      <CustomModal title="Attachments" onClose={onClose}>
        <div className="t-files">
          {attachments.length > 0 ? (
            attachments.map((line, index) => {
              return (
                <a
                  className="file-name"
                  href={splitFileName(line)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div
                    className="attachment-container attachment-download-bg"
                    key={index + 1}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gridGap: "10px",
                      }}
                    >
                      {getIconByFileType(line)}

                      {getFileNameFromUrl(line, 50)}
                    </Box>
                  </div>
                </a>
              );
            })
          ) : (
            <Typography sx={{ textAlign: "center", width: "100%" }}>
              No Documents Found
            </Typography>
          )}
        </div>
        {isOemDownload && attachments.length > 0 && (
          <Typography color="error" sx={{ mt: 4 }}>
            WARNING: You are about to access confidential files within the
            software. These files contain sensitive information and are only
            accessible to authorized personnel. Editing / Sharing is strictly
            prohibited.
          </Typography>
        )}
      </CustomModal>
    </div>
  );
};

export default AttachmentModal;
